import type { MakeInputProps } from '@frontend/forms';
import type { WebTestId } from '@frontend/test-utils';
import { safeCss } from '@frontend/web-utils';
import type { PasswordInputProps as MPasswordInputProps } from '@mantine/core';
import { PasswordInput as MPasswordInput } from '@mantine/core';
import type { SetOptional } from 'type-fest';
import type { AccessibilityLabelProps } from '../../../../../types/accessibility';
import { Icon } from '../../../Icon/Icon';
import { InputLabel, type InputLabelProps } from '../../InputLabel';
import { textInputClassNames } from './TextInput';

type PasswordInputProps = AccessibilityLabelProps &
  SetOptional<
    MakeInputProps<string, MPasswordInputProps, 'autoComplete' | 'classNames' | 'type' | 'visibilityToggleIcon'>,
    'label'
  > & {
    labelTextProps?: InputLabelProps['textProps'];
    testId?: WebTestId;
  };

const passwordInputClassNames: MPasswordInputProps['classNames'] = {
  input: textInputClassNames.input,
  root: textInputClassNames.root,
  section: safeCss('right-md'),
};

export const PasswordInput = ({
  accessibilityLabel,
  label = 'Password',
  labelTextProps,
  onChange,
  placeholder = 'Enter password',
  testId,
  ...props
}: PasswordInputProps) => {
  return (
    <MPasswordInput
      aria-label={accessibilityLabel || label}
      classNames={passwordInputClassNames}
      data-testid={testId}
      label={<InputLabel label={label} textProps={labelTextProps} />}
      onChange={(event) => {
        onChange(event.target.value);
      }}
      placeholder={placeholder}
      type="password"
      visibilityToggleIcon={({ reveal }) => <Icon name={reveal ? 'IconEyeOff' : 'IconEye'} />}
      {...props}
    />
  );
};
